export default {
  hero: {
    "title-line-1": "Accédez à une électricité solaire locale moins chère",
    "title-line-2": "sans panneaux chez vous",
    description:
      "Rejoignez une communauté solaire près de chez vous, réduisez votre facture d'électricité et soutenez les énergies renouvelables locales.",
    "cta-find-community": "Trouver une communauté près de moi",
    "cta-check-eligibility": "Vérifier mon éligibilité",
    "savings-title": "Vos économies estimées",
    "community-rate": "Tarif communautaire",
    "annual-savings": "Économies annuelles",
    "annual-consumption": "Consommation annuelle (kWh)",
    "current-rate": "Tarif actuel (€/kWh)",
    "slider-hint":
      "Il s'agit d'économies estimées basées sur les tarifs solaires communautaires habituels. Les économies réelles peuvent varier.",
  },
  "why-join": {
    title: "Pourquoi rejoindre une communauté solaire ?",
    subtitle:
      "Accédez à l'énergie renouvelable sans les tracas ni les frais liés à l'installation de vos propres panneaux.",
    cards: {
      "no-investment": {
        title: "Aucun investissement requis",
        description: "Pas de panneaux, pas d'installation, pas de frais initiaux.",
      },
      "fixed-pricing": {
        title: "Tarification fixe et prévisible",
        description: "Taux stables protégés contre la volatilité du marché.",
      },
      "support-local": {
        title: "Soutenez l'énergie locale",
        description: "Alimentez votre maison en électricité provenant de producteurs locaux.",
      },
    },
  },
  "how-it-works": {
    title: "Comment ça marche",
    subtitle: "La mise en route est simple et sans effort.",
    steps: {
      "step-1": {
        number: "01",
        title: "Trouvez une communauté près de chez vous",
        description: "Parcourez les communautés solaires disponibles dans votre région",
      },
      "step-2": {
        number: "02",
        title: "Inscrivez-vous avec votre adresse + PDL",
        description: "Remplissez un simple formulaire d'inscription",
      },
      "step-3": {
        number: "03",
        title: "Donnez votre consentement pour l'accès aux données du compteur",
        description: "Accès sécurisé via l'API Enedis",
      },
      "step-4": {
        number: "04",
        title: "Commencez à recevoir de l'énergie solaire locale",
        description: "Commencez à économiser sur votre facture d'électricité",
      },
    },
  },
  "can-you-join": {
    title: "Pouvez-vous joindre à nous ?",
    subtitle: "La plupart des ménages sont déjà éligibles",
    subtext: "95 % des ménages français sont déjà éligibles",
    criteria: {
      linky: "Compteur Linky installé",
      distance: "Situé à moins de 2 à 20 km d'une communauté solaire",
      supplier: "Conservez votre fournisseur d'électricité actuel",
    },
    cta: "Vérifier mon éligibilité",
    "image-alt": "Maison avec panneaux solaires - illustration",
  },
  "explore-communities": {
    title: "Découvrez les communautés près de chez vous",
    subtitle: "Trouvez la communauté solaire idéale dans votre région",
    "filters-title": "Filtres",
    filters: {
      "sort-by": {
        label: "Trier par",
        options: {
          nearest: "Plus proches d'abord",
          "price-asc": "Prix (croissant)",
          "price-desc": "Prix (décroissant)",
          capacity: "Capacité",
        },
      },
      "max-price": {
        label: "Prix max",
        options: {
          "0.165": "jusqu'à 0,165 kWh",
          "0.170": "jusqu'à 0,170 kWh",
          "0.175": "jusqu'à 0,175 kWh",
          "0.180": "jusqu'à 0,180 kWh",
        },
      },
      "max-distance": {
        label: "Distance max",
        options: {
          "5": "Dans un rayon de 5 km",
          "10": "Dans un rayon de 10 km",
          "15": "Dans un rayon de 15 km",
          "20": "Dans un rayon de 20 km",
        },
      },
    },
    available: "Disponible",
    full: "Complet",
    "join-community": "Rejoindre la communauté",
    "join-waitlist": "Rejoindre la liste d'attente",
    "map-placeholder": "Carte",
  },
  "join-in-three-steps": {
    title: "Inscrivez-vous en 3 étapes simples",
    subtitle: "Rapide, facile et entièrement en ligne",
    steps: {
      "step-1": {
        title: "Entrez votre adresse e-mail + adresse postale",
        description: "Coordonnées de base pour commencer",
      },
      "step-2": {
        title: "Fournir le PDL + consentement",
        description: "Votre numéro Point de Livraison pour accéder au compteur",
      },
      "step-3": {
        title: "Commencez à recevoir l'énergie solaire",
        description: "Commencez dès maintenant à faire des économies grâce à l'énergie solaire locale",
      },
    },
  },
  "keep-your-supplier": {
    title: "Conservez votre fournisseur d'électricité",
    body: "L'énergie solaire communautaire complète votre fournisseur d'électricité actuel, elle ne le remplace pas. Vous continuerez à recevoir votre facture d'électricité habituelle de votre fournisseur (EDF, Engie, etc.), mais l'énergie consommée provenant de votre communauté solaire sera facturée à un tarif réduit. Votre fournisseur continue de gérer le raccordement au réseau, le service client et tous les frais réglementés (TURPE, taxes). L'énergie solaire communautaire vous fournit simplement une énergie renouvelable locale moins chère.",
    "bill-title": "Votre facture d'électricité",
    "bill-items": {
      "community-solar": {
        label: "Solaire communautaire",
        description: "Énergie renouvelable locale à tarif réduit",
      },
      "supplier-portion": {
        label: "Partie fournisseur",
        description: "Redevances d'utilisation du réseau (TURPE), taxes et services",
      },
    },
    "bill-footnote": "Une facture, deux sources — intégration transparente",
  },
  "track-your-impact": {
    title: "Suivez votre impact",
    subtitle:
      "Accédez à votre tableau de bord pour suivre vos économies et votre impact environnemental",
    "image-alt": "Tableau de bord - suivi de votre impact",
  },
  "already-have-panels": {
    title: "Vous avez déjà des panneaux solaires ?",
    subtitle:
      "Gagnez plus en vendant localement. Rejoignez notre réseau de producteurs et valorisez votre installation.",
    cta: "Devenir producteur",
  },
  cta: {
    title: "Rejoignez une communauté solaire près de chez vous",
    subtitle:
      "Commencez à économiser sur votre facture d'électricité tout en soutenant les énergies renouvelables locales.",
    button: "Trouver une communauté près de chez moi",
  },
}
